var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectedTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9996 0C6.72855 0 0 6.72875 0 15C0 23.2712 6.72855 30 14.9996 30C23.2706 30 29.9991 23.2712 29.9991 15C29.9991 6.72875 23.2706 0 14.9996 0ZM22.6018 11.8212L14.4771 19.9462C14.2333 20.19 13.9133 20.3125 13.5933 20.3125C13.2734 20.3125 12.9534 20.19 12.7096 19.9462L8.64724 15.8837C8.15851 15.395 8.15851 14.605 8.64724 14.1163C9.13598 13.6275 9.92595 13.6275 10.4147 14.1163L13.5933 17.295L20.8344 10.0538C21.3231 9.565 22.1131 9.565 22.6018 10.0538C23.0906 10.5425 23.0906 11.3325 22.6018 11.8212Z",
    fill: "#64D371"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedTick);
export default __webpack_public_path__ + "static/media/selectedTick.55dab3d7231f2b0619162ffbb4c5c54b.svg";
export { ForwardRef as ReactComponent };